/**
 * dercomputerladen – Barrierefreiheits-Widget
 * BFSG-konform | WCAG 2.1 Level AA | EN 301 549
 *
 * Einbinden: Diesen Block vor </body> in theme.liquid einfügen.
 * CSS:       {{ 'accessibility.css' | asset_url | stylesheet_tag }}
 *            → in den <head> von theme.liquid
 *
 * Pflicht gemäß § 16 BFSG:
 *   → Barrierefreiheitserklärung unter /pages/barrierefreiheit anlegen!
 */

(function () {
  'use strict';

  /* ── Konfiguration ─────────────────────────────────────── */
  var CONFIG = {
    position:    'bottom-right',   // bottom-right | bottom-left | top-right | top-left
    accentColor: '#e87722',        // DCL Orange
    declarationUrl: '/pages/barrierefreiheit', // Pflicht-Seite gemäß § 16 BFSG
    storageKey: 'dcl_bfsg_acc',
  };

  /* ── Standardwerte ─────────────────────────────────────── */
  var DEFAULTS = {
    fontSize:      0,   // 0–4
    lineHeight:    0,   // 0–4
    letterSpacing: 0,   // 0–4
    wordSpacing:   0,   // 0–4
    contrast:      false,
    grayscale:     false,
    invert:        false,
    highlight:     false,
    animations:    false,
    focus:         false,
    cursor:        false,
    dyslexia:      false,
    readingGuide:  false,
  };

  var FONT_SIZES      = ['','110','120','135','150'];
  var LINE_HEIGHTS    = ['','15','18','20','24'];
  var LETTER_SPACINGS = ['',  '1',  '2',  '3',  '4'];
  var WORD_SPACINGS   = ['',  '1',  '2',  '3',  '4'];

  /* ── Labels ────────────────────────────────────────────── */
  var FEATURES = [
    { id: 'fontSize',      type: 'scale', max: 4, icon: 'Aa', label: 'Schriftgröße',     desc: 'Text vergrößern (WCAG 1.4.4)',      vals: ['Standard','110 %','120 %','135 %','150 %'] },
    { id: 'lineHeight',    type: 'scale', max: 4, icon: '↕',  label: 'Zeilenabstand',    desc: 'Abstände erhöhen (WCAG 1.4.12)',    vals: ['Standard','1.5×','1.8×','2.0×','2.4×']    },
    { id: 'letterSpacing', type: 'scale', max: 4, icon: 'A↔', label: 'Buchstabenabstand',desc: 'Zeichenabstand (WCAG 1.4.12)',      vals: ['Standard','+0.05','+0.1','+0.15','+0.2']  },
    { id: 'wordSpacing',   type: 'scale', max: 4, icon: 'W↔', label: 'Wortabstand',      desc: 'Wortabstand (WCAG 1.4.12)',         vals: ['Standard','+0.1','+0.2','+0.3','+0.4']    },
    { id: 'contrast',   type: 'toggle', icon: '◑', label: 'Hoher Kontrast',    desc: 'Kontrast 4,5:1 (WCAG 1.4.3)'    },
    { id: 'grayscale',  type: 'toggle', icon: '◫', label: 'Graustufen',        desc: 'Keine Farbe als Signal (WCAG 1.4.1)'},
    { id: 'invert',     type: 'toggle', icon: '☀', label: 'Invertieren',       desc: 'Farben umkehren (WCAG 1.4.3)'    },
    { id: 'highlight',  type: 'toggle', icon: '🔗',label: 'Links hervorheben', desc: 'Links erkennbar (WCAG 1.4.1)'    },
    { id: 'animations', type: 'toggle', icon: '⏸', label: 'Animationen stoppen',desc:'< 3 Hz Blitzen (WCAG 2.3.1)'     },
    { id: 'focus',      type: 'toggle', icon: '⬡', label: 'Fokus hervorheben', desc: 'Tastaturfokus sichtbar (WCAG 2.4.7)'},
    { id: 'cursor',     type: 'toggle', icon: '↖', label: 'Großer Cursor',     desc: 'Mauszeiger vergrößern'           },
    { id: 'dyslexia',   type: 'toggle', icon: 'B', label: 'Leseschrift',        desc: 'Lesbare Schrift (WCAG 1.4.4)'    },
    { id: 'readingGuide',type:'toggle', icon: '▶', label: 'Lesehilfe',          desc: 'Fokus-Linie'                     },
  ];

  /* ── State laden ───────────────────────────────────────── */
  var state = Object.assign({}, DEFAULTS);
  try {
    var saved = JSON.parse(localStorage.getItem(CONFIG.storageKey) || '{}');
    Object.keys(DEFAULTS).forEach(function (k) {
      if (k in saved) state[k] = saved[k];
    });
  } catch (e) {}

  function saveState() {
    try { localStorage.setItem(CONFIG.storageKey, JSON.stringify(state)); } catch (e) {}
  }

  /* ── HTML aufbauen ─────────────────────────────────────── */

  // Skip-Link (WCAG 2.4.1)
  var skip = document.createElement('a');
  skip.id   = 'acc-skip-link';
  skip.href = '#MainContent';
  skip.textContent = 'Zum Hauptinhalt springen';
  document.body.insertBefore(skip, document.body.firstChild);

  // Lesehilfe-Element
  var guide = document.createElement('div');
  guide.id = 'acc-reading-guide';
  guide.setAttribute('aria-hidden', 'true');
  document.body.appendChild(guide);

  // Widget-Button (WCAG 4.1.2)
  var btn = document.createElement('button');
  btn.id   = 'acc-widget-btn';
  btn.setAttribute('aria-label', 'Barrierefreiheits-Einstellungen öffnen');
  btn.setAttribute('aria-haspopup', 'dialog');
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', 'acc-panel');
  btn.innerHTML = '&#128065;';
  document.body.appendChild(btn);

  // Panel (WCAG 4.1.2 role=dialog)
  var panel = document.createElement('div');
  panel.id  = 'acc-panel';
  panel.setAttribute('role', 'dialog');
  panel.setAttribute('aria-modal', 'true');
  panel.setAttribute('aria-labelledby', 'acc-panel-title');
  panel.setAttribute('tabindex', '-1');

  // Panel-Header
  var header = document.createElement('div');
  header.id  = 'acc-panel-header';
  header.innerHTML =
    '<div>' +
      '<p id="acc-panel-title">&#9851; Barrierefreiheit</p>' +
      '<p id="acc-panel-subtitle">BFSG &middot; WCAG 2.1 AA &middot; dercomputerladen</p>' +
    '</div>' +
    '<button id="acc-close-btn" aria-label="Einstellungen schließen">&#x2715;</button>';
  panel.appendChild(header);

  // Panel-Body
  var body = document.createElement('div');
  body.id  = 'acc-panel-body';

  FEATURES.forEach(function (f) {
    var row  = document.createElement('div');
    row.className = 'acc-row';
    row.dataset.feature = f.id;

    var icon = document.createElement('div');
    icon.className = 'acc-row-icon';
    icon.setAttribute('aria-hidden', 'true');
    icon.textContent = f.icon;

    var text = document.createElement('div');
    text.className = 'acc-row-text';

    var lbl  = document.createElement('label');
    lbl.className = 'acc-row-label';
    lbl.htmlFor   = 'acc-ctrl-' + f.id;
    lbl.textContent = f.label;

    var desc = document.createElement('span');
    desc.className = 'acc-row-desc';
    desc.textContent = f.desc;

    text.appendChild(lbl);
    text.appendChild(desc);

    var ctrl;

    if (f.type === 'toggle') {
      // WCAG 4.1.2 – role=switch
      ctrl = document.createElement('button');
      ctrl.id = 'acc-ctrl-' + f.id;
      ctrl.className = 'acc-toggle';
      ctrl.setAttribute('role', 'switch');
      ctrl.setAttribute('aria-checked', state[f.id] ? 'true' : 'false');
      ctrl.setAttribute('aria-label', f.label);
      ctrl.addEventListener('click', function () {
        state[f.id] = !state[f.id];
        applyAll();
      });

    } else {
      // Scale-Control
      ctrl = document.createElement('div');
      ctrl.className = 'acc-scale';

      var minus = document.createElement('button');
      minus.className = 'acc-scale-btn';
      minus.setAttribute('aria-label', f.label + ' verringern');
      minus.textContent = '−';

      var valSpan = document.createElement('span');
      valSpan.className = 'acc-scale-val';
      valSpan.id = 'acc-ctrl-' + f.id;
      valSpan.setAttribute('aria-live', 'polite');
      valSpan.setAttribute('aria-label', f.label + ' Wert');

      var plus = document.createElement('button');
      plus.className = 'acc-scale-btn';
      plus.setAttribute('aria-label', f.label + ' erhöhen');
      plus.textContent = '+';

      minus.addEventListener('click', function () {
        if (state[f.id] > 0) { state[f.id]--; applyAll(); }
      });
      plus.addEventListener('click', function () {
        if (state[f.id] < f.max) { state[f.id]++; applyAll(); }
      });

      ctrl.appendChild(minus);
      ctrl.appendChild(valSpan);
      ctrl.appendChild(plus);
    }

    row.appendChild(icon);
    row.appendChild(text);
    row.appendChild(ctrl);
    body.appendChild(row);
  });

  // Reset-Button
  var resetBtn = document.createElement('button');
  resetBtn.id  = 'acc-reset-btn';
  resetBtn.textContent = '↺ Alle Einstellungen zurücksetzen';
  resetBtn.addEventListener('click', function () {
    state = Object.assign({}, DEFAULTS);
    applyAll();
  });
  body.appendChild(resetBtn);

  // Barrierefreiheitserklärung-Link (§ 16 BFSG Pflicht)
  var declLink = document.createElement('a');
  declLink.id   = 'acc-declaration-link';
  declLink.href = CONFIG.declarationUrl;
  declLink.textContent = 'Barrierefreiheitserklärung (§ 16 BFSG)';
  body.appendChild(declLink);

  panel.appendChild(body);
  document.body.appendChild(panel);

  /* ── CSS auf <html> anwenden ───────────────────────────── */
  function applyAll() {
    var html = document.documentElement;

    // Alle acc-Klassen entfernen
    html.className = html.className
      .replace(/\bacc-[a-z0-9-]+\b/g, '')
      .replace(/\s+/g, ' ')
      .trim();

    // Position
    html.classList.add('acc-pos-' + CONFIG.position);

    // Schrift-Skalierungen
    if (state.fontSize > 0)
      html.classList.add('acc-fontsize-' + FONT_SIZES[state.fontSize]);
    if (state.lineHeight > 0)
      html.classList.add('acc-lineheight-' + LINE_HEIGHTS[state.lineHeight]);
    if (state.letterSpacing > 0)
      html.classList.add('acc-letterspacing-' + LETTER_SPACINGS[state.letterSpacing]);
    if (state.wordSpacing > 0)
      html.classList.add('acc-wordspacing-' + WORD_SPACINGS[state.wordSpacing]);

    // Toggles
    var toggles = ['contrast','grayscale','invert','highlight',
                   'animations','focus','dyslexia','readingGuide'];
    toggles.forEach(function (k) {
      if (state[k]) html.classList.add('acc-' + k.toLowerCase());
    });

    // Cursor
    if (state.cursor) {
      document.body.style.cursor = 'url("data:image/svg+xml,%3Csvg xmlns=\'http://www.w3.org/2000/svg\' width=\'40\' height=\'40\' viewBox=\'0 0 40 40\'%3E%3Cpath d=\'M6 4l26 12-11 5-4 12z\' fill=\'%23000\' stroke=\'%23fff\' stroke-width=\'2\'/%3E%3C/svg%3E") 6 6, auto';
    } else {
      document.body.style.cursor = '';
    }

    // UI synchronisieren
    syncUI();
    saveState();
  }

  function syncUI() {
    FEATURES.forEach(function (f) {
      var row  = panel.querySelector('[data-feature="' + f.id + '"]');
      var ctrl = document.getElementById('acc-ctrl-' + f.id);
      if (!row || !ctrl) return;

      if (f.type === 'toggle') {
        var checked = !!state[f.id];
        ctrl.setAttribute('aria-checked', checked ? 'true' : 'false');
        row.classList.toggle('acc-active', checked);
      } else {
        var valMap = { fontSize: FONT_SIZES, lineHeight: LINE_HEIGHTS,
                       letterSpacing: LETTER_SPACINGS, wordSpacing: WORD_SPACINGS };
        var vals   = valMap[f.id];
        if (vals) {
          ctrl.textContent = f.vals[state[f.id]];
          var active = state[f.id] > 0;
          row.classList.toggle('acc-active', active);
          var minus = ctrl.previousElementSibling;
          var plus  = ctrl.nextElementSibling;
          if (minus) minus.disabled = state[f.id] === 0;
          if (plus)  plus.disabled  = state[f.id] === f.max;
        }
      }
    });
  }

  /* ── Lesehilfe: Linie folgt Maus ───────────────────────── */
  document.addEventListener('mousemove', function (e) {
    if (!state.readingGuide) return;
    guide.style.top = (e.clientY - 18) + 'px';
  });

  /* ── Dialog öffnen / schließen ─────────────────────────── */
  var lastFocus = null;

  function openPanel() {
    lastFocus = document.activeElement;
    panel.classList.add('acc-open');
    btn.setAttribute('aria-expanded', 'true');
    panel.focus();
  }

  function closePanel() {
    panel.classList.remove('acc-open');
    btn.setAttribute('aria-expanded', 'false');
    if (lastFocus) lastFocus.focus();
  }

  btn.addEventListener('click', function () {
    panel.classList.contains('acc-open') ? closePanel() : openPanel();
  });

  document.getElementById('acc-close-btn').addEventListener('click', closePanel);

  // ESC schließt Dialog (WCAG 2.1.2)
  panel.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') { closePanel(); return; }

    // Fokus-Falle (WCAG 2.1.2)
    if (e.key !== 'Tab') return;
    var focusable = Array.prototype.slice.call(
      panel.querySelectorAll('button:not(:disabled), a[href], [tabindex="0"]')
    );
    var first = focusable[0];
    var last  = focusable[focusable.length - 1];
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last)  { e.preventDefault(); first.focus(); }
    }
  });

  // Klick außerhalb schließt Panel
  document.addEventListener('click', function (e) {
    if (panel.classList.contains('acc-open') &&
        !panel.contains(e.target) &&
        e.target !== btn) {
      closePanel();
    }
  });

  /* ── Initiales Anwenden ────────────────────────────────── */
  applyAll();

})();
